import styled, { css } from 'styled-components';

export const DivContainerStyled = styled.div`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    return css`
      {
        margin-bottom: 1rem !important;
        padding: 1rem !important; 
        background-color: ${theme.colors.neutral.grey99};
        max-width: 450px;
      }
    `;
  }}
`;
